import { render, staticRenderFns } from "./DetailCatalog.vue?vue&type=template&id=8ced703e&scoped=true&"
import script from "./DetailCatalog.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailCatalog.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailCatalog.vue?vue&type=style&index=0&id=8ced703e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ced703e",
  null
  
)

export default component.exports